var map = {
	"./authentication/authentication.module": [
		"./src/app/authentication/authentication.module.ts",
		"authentication-authentication-module"
	],
	"./dashboards/dashboards.module": [
		"./src/app/dashboards/dashboards.module.ts",
		"default~dashboards-dashboards-module~faqs-faqs-module~news-news-module~notifications-notifications-m~76212638",
		"dashboards-dashboards-module"
	],
	"./faqs/faqs.module": [
		"./src/app/faqs/faqs.module.ts",
		"default~dashboards-dashboards-module~faqs-faqs-module~news-news-module~notifications-notifications-m~76212638",
		"default~faqs-faqs-module~news-news-module~notifications-notifications-module~pages-pages-module~user~b542e549",
		"faqs-faqs-module"
	],
	"./material-component/material.module": [
		"./src/app/material-component/material.module.ts",
		"material-component-material-module"
	],
	"./news/news.module": [
		"./src/app/news/news.module.ts",
		"default~dashboards-dashboards-module~faqs-faqs-module~news-news-module~notifications-notifications-m~76212638",
		"default~faqs-faqs-module~news-news-module~notifications-notifications-module~pages-pages-module~user~b542e549",
		"news-news-module"
	],
	"./notifications/notifications.module": [
		"./src/app/notifications/notifications.module.ts",
		"default~dashboards-dashboards-module~faqs-faqs-module~news-news-module~notifications-notifications-m~76212638",
		"default~faqs-faqs-module~news-news-module~notifications-notifications-module~pages-pages-module~user~b542e549",
		"notifications-notifications-module"
	],
	"./pages/pages.module": [
		"./src/app/pages/pages.module.ts",
		"default~dashboards-dashboards-module~faqs-faqs-module~news-news-module~notifications-notifications-m~76212638",
		"default~faqs-faqs-module~news-news-module~notifications-notifications-module~pages-pages-module~user~b542e549",
		"pages-pages-module"
	],
	"./users/users.module": [
		"./src/app/users/users.module.ts",
		"default~dashboards-dashboards-module~faqs-faqs-module~news-news-module~notifications-notifications-m~76212638",
		"default~faqs-faqs-module~news-news-module~notifications-notifications-module~pages-pages-module~user~b542e549",
		"users-users-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;